export default __webpack_public_path__ + "static/media/Instagram-icon-secondary-color.35b7180d.svg";